import styled from 'styled-components';
import { CaptionText, P3 } from '../../styles/FontStyles';
import { Flexed } from '../../styles/GlobalComponents';
import { colors } from '../../styles/GlobalStyles';
import { Icon, IconInfo } from '../../styles/Icons';
import { Checkbox } from './Checkbox/Checkbox';

const ComponentStyled = styled.div`
  min-height: 24px;
  margin-bottom: 12px;
`;

const CheckLabel = styled(P3)`
  @media (max-width: 800px) {
    font-size: 12px;
    line-height: 18px;
  }
`;

const CheckSmallLabel = styled(CaptionText)`
  @media (max-width: 800px) {
    font-size: 11px;
    line-height: 16px;
  }
`;

interface CheckTextType {
  text?: string;
  info?: string;
  x?: boolean;
  checked?: boolean;
  onClick?: () => void;
  smallText?: string;
  checkColor?: string;
}

export const CheckText = ({
  text,
  info,
  x,
  checked = true,
  onClick,
  smallText,
  checkColor
}: CheckTextType) => {
  return (
    <ComponentStyled>
      <Flexed center>
        <Checkbox
          size={'24'}
          checked={checked}
          margin='0 12px 0 0'
          x={x}
          onClick={onClick}
          checkColor={checkColor}
        />
        <CheckLabel color={colors.primary900} semiBold>
          {text}
        </CheckLabel>
      </Flexed>

      {smallText && (
        <CheckSmallLabel ml='36' color={colors.neutral500}>
          {smallText}
        </CheckSmallLabel>
      )}
      {info && (
        <Icon ml='8'>
          <IconInfo />
        </Icon>
      )}
    </ComponentStyled>
  );
};
